<div class="house-views-readonly-card card">
  <div
    class="card-header d-flex align-items-center justify-content-between"
    [class.section-disabled]="allDisabled"
  >
    <div class="d-flex align-items-center">
      <mat-icon class="cursor-pointer me-2" (click)="collapsed = !collapsed">
        {{ collapsed ? "chevron_right" : "expand_more" }}
      </mat-icon>
      <strong>{{ label }}</strong>
    </div>
    <mat-slide-toggle
      color="primary"
      [checked]="masterEnabled"
      (change)="onMasterToggle($event)"
    >
    </mat-slide-toggle>
  </div>

  @if (!collapsed) {
    <div class="card-body">
      @if (views.length) {
        <table class="table">
          <thead>
            <tr>
              <td>Object</td>
              <td class="text-end">Value</td>
              <td>Confidence</td>
              <td>Frequency</td>
              <td class="text-center"></td>
            </tr>
          </thead>
          <tbody>
            @for (v of views; track v.id) {
              <tr [class.row-disabled]="enabledMap[getViewKey(v)] === false">
                <td>
                  <span
                    [matTooltip]="getItemNames(v, true)"
                    matTooltipPosition="right"
                    >{{ getItemNames(v) }}</span
                  >
                </td>
                <td class="text-end number-col pe-4">
                  {{ v.value | number: "1.0-2" }}%
                </td>
                <td class="number-col pe-4">
                  {{ v.confidence | confidenceLabel }}
                </td>
                <td class="text-capitalize">{{ v.frequency }}</td>
                <td class="text-center">
                  <mat-slide-toggle
                    color="primary"
                    [checked]="enabledMap[getViewKey(v)] !== false"
                    (change)="onViewToggle(v, $event)"
                  >
                  </mat-slide-toggle>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
      @if (!views.length) {
        <p class="text-muted text-center py-3">No views configured.</p>
      }
    </div>
  }
</div>
